import z from 'zod';
import { platforms } from '../../config';
import { kebabString } from '../../custom-events/base-fields';

const environments = ['local', 'development', 'acceptance', 'production'] as const;
type Environment = typeof environments;
type Environments = [
  ...Environment,
  ...{ [T in keyof Environment]: Environment[T] extends string ? Capitalize<Environment[T]> : never },
];

const opcos = ['noordhoff', 'liber', 'plantyn'] as const;
type Opco = typeof opcos;
type Opcos = [...Opco, ...{ [T in keyof Opco]: Opco[T] extends string ? Capitalize<Opco[T]> : never }];

export default z.object({
  platform: z.enum(platforms),
  environment: z
    .string()
    .transform(val => val.toLowerCase())
    .refine(val => environments.includes(val as Environment[number]), {
      message: `Value must be one of '${environments.join("', '")}'`,
    }) as unknown as z.ZodEnum<Environments>,
  opCo: z
    .string()
    .transform(val => val.toLowerCase())
    .refine(val => opcos.includes(val as Opco[number]), { message: `Value must be one of '${opcos.join("', '")}'` })
    .optional() as unknown as z.ZodOptional<z.ZodEnum<Opcos>>,
  platformVersion: z.string().optional(),
  platformVariant: kebabString.optional(),
});
